import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    HeaderActionsService,
    CopyDetailsService,
    MenuService,
    MyItemsService,
    MyItemsStore,
    CorrectionsMenuFactory
} from './infrastructure';
import { MenuStore } from './infrastructure/menu.store';
import {
    MenuBuilderService,
    AllProjectMenuBuilderService,
    InProjectMenuBuilderService,
    SettingsMenuBuilderService,
    InSystemMenuBuilderService,
    MegaMenuBuilderService,
    MenuBuilderCollectionService
} from './infrastructure/builders';
import { InReleaseMenuBuilderService } from './infrastructure/builders/in-release-menu-builder';
import { DevelopmentMenuFactory } from './infrastructure/builders/in-project/development-menu-factory';
import { TestsMenuFactory } from './infrastructure/builders/in-project/tests-menu-factory';
import { RequestStatusFetcherService } from './infrastructure/request-status-fetcher.service';
import { UserNotificationsService } from './infrastructure/user-notification/user-notifications.service';
import { UserNotificationsStore } from './infrastructure/user-notification/user-notifications.store';

export const MENU_BUILDER_SERVICE = new InjectionToken<MenuBuilderService>('MenuBuilderService');

@NgModule({
    imports: [CommonModule],
    providers: [
        MenuService,
        MenuStore,
        { provide: MENU_BUILDER_SERVICE, useClass: AllProjectMenuBuilderService, multi: true },
        { provide: MENU_BUILDER_SERVICE, useClass: InProjectMenuBuilderService, multi: true },
        { provide: MENU_BUILDER_SERVICE, useClass: SettingsMenuBuilderService, multi: true },
        { provide: MENU_BUILDER_SERVICE, useClass: InReleaseMenuBuilderService, multi: true },
        { provide: MENU_BUILDER_SERVICE, useClass: InSystemMenuBuilderService, multi: true },
        MenuBuilderCollectionService,
        MegaMenuBuilderService,
        DevelopmentMenuFactory,
        CorrectionsMenuFactory,
        TestsMenuFactory,
        MyItemsService,
        MyItemsStore,
        RequestStatusFetcherService,
        HeaderActionsService,
        UserNotificationsService,
        UserNotificationsStore,
        CopyDetailsService
    ]
})
export class MainHeaderDomainModule {}
